"use client";

import { useParams } from "next/navigation";
import type { ReactElement } from "react";
import { MaintenanceScreen } from "@/app/maintenance/_components/maintenance-screen/maintenance-screen";
import { Dialog, DialogContent, DialogTitle } from "@/components/ui/dialog";
import { useTranslation } from "@/i18n/client";
import { fallbackLng, languages } from "@/i18n/settings";

function resolveLanguage(value: unknown): string {
  if (typeof value === "string" && languages.includes(value)) {
    return value;
  }

  return fallbackLng;
}

function preventDismiss(event: Event): void {
  event.preventDefault();
}

export function MaintenanceLock(): ReactElement {
  const params = useParams();
  const lng = resolveLanguage(params?.lng);
  const { t } = useTranslation("maintenance", lng, { lng });

  return (
    <Dialog open={true}>
      <DialogContent
        hasCloseButton={false}
        onEscapeKeyDown={preventDismiss}
        onInteractOutside={preventDismiss}
        className="top-0 left-0 z-[100] block h-dvh w-full max-w-none translate-x-0 translate-y-0 overflow-y-auto overscroll-contain rounded-none border-0 bg-neutral-0 p-0 shadow-none data-[state=open]:animate-none! md:max-w-none"
      >
        <DialogTitle className="sr-only">{t("title")}</DialogTitle>
        <MaintenanceScreen lng={lng} />
      </DialogContent>
    </Dialog>
  );
}
